export default {"src":"/_next/static/media/membership-2.13e786a1.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};